<template>
  <div>
    <div class="banner">
      <img src="@/assets/images/case.jpg">
    </div>
    <CaseModule/>
  </div>
</template>

<script>
import CaseModule from '@/components/CaseModule.vue';
export default {
  components: { CaseModule, },
  name: 'CustomerCase',  // 组件名称
};
</script>

<style scoped>
.banner{
  width: 100%;
}
.banner img{
  display: block;
  width: 100%;
}

</style>
